import React from 'react';
import { IThumbnail } from 'utils/entities';
import { ShowAt } from 'consts/breakpoints';
import { Pager } from 'components/cards/listing/Pager';
import { PagerWrapper, ControlsArrowProps, ControlsBox, ControlsBoxMask, ControlsArrowWrapper } from './styled';
import ControlsIcon from 'assets/svg/control-chevron.svg';

export const ControlsArrow: React.FunctionComponent<ControlsArrowProps> = (props) => (
  <ControlsArrowWrapper {...props}>
    <ControlsIcon />
  </ControlsArrowWrapper>
);

interface GalleryPagerProps {
  images: IThumbnail[];
  activeSlide: number;
  handleNextSlide(): void;
  handlePrevSlide(): void;
  handleSlideIndexChange(idx: number): void;
  openFullscreen(isMobile: boolean): () => void;
  isShortWidth: boolean;
}

export const GalleryPager: React.FunctionComponent<GalleryPagerProps> = ({
  images,
  activeSlide,
  handleSlideIndexChange,
  handleNextSlide,
  handlePrevSlide,
  isShortWidth,
  openFullscreen,
}) => (
  <>
    <ShowAt to={2}>
      <PagerWrapper>
        <Pager
          total={images.length}
          onChangeIndex={handleSlideIndexChange}
          index={activeSlide}
          limit={5}
        />
      </PagerWrapper>
    </ShowAt>
    <ShowAt from={3}>
      {images.length > 1 ? (
        <ControlsBox short={isShortWidth}>
          <ControlsBoxMask onClick={openFullscreen(false)}/>
          <ControlsArrow dir="prev" onClick={handlePrevSlide}/>
          <ControlsArrow dir="next" onClick={handleNextSlide}/>
        </ControlsBox>
      ) : null}
    </ShowAt>
  </>
);
